/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Tomorrow_ColourInputs */

const en_attribute_tomorrow_colour = /** @type {(inputs: Attribute_Tomorrow_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow colour`)
};

/**
* | output |
* | --- |
* | "Tomorrow colour" |
*
* @param {Attribute_Tomorrow_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_tomorrow_colour = /** @type {((inputs?: Attribute_Tomorrow_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Tomorrow_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_tomorrow_colour(inputs)
});